import { connect } from "react-redux";

import Login from 'components/answer/Login';

const mapStateToProps = state => state;

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchLogin: () => {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/answer/ReportLoginContainer.js